var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5,
    fill: "#0355FF",
    stroke: "#0355FF",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6875 5.86819V12.9229H6.70182V5.86819H8.6875ZM7.69792 3.10437C7.99306 3.10437 8.24696 3.17168 8.45964 3.30629C8.67231 3.4367 8.77865 3.6828 8.77865 4.04457C8.77865 4.40215 8.67231 4.65034 8.45964 4.78917C8.24696 4.92378 7.99306 4.99109 7.69792 4.99109C7.39844 4.99109 7.14236 4.92378 6.92969 4.78917C6.72135 4.65034 6.61719 4.40215 6.61719 4.04457C6.61719 3.6828 6.72135 3.4367 6.92969 3.30629C7.14236 3.17168 7.39844 3.10437 7.69792 3.10437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoColored);
export default __webpack_public_path__ + "static/media/info-colored.68f4c91a4e2e12f651299d38c80d316d.svg";
export { ForwardRef as ReactComponent };